import { formats } from '@comall-backend-builder/types';

export class StringImagePickerPZGFormat extends formats.StringFormat {
    /**
     * 将数据格式化为请求参数
     */
    public formatParams(key: any, value: any) {
        let path = '';
        if (value && typeof value === 'string') {
            path = value;
        } else if (Array.isArray(value)) {
            path = value[0];
        }
        return { [key]: path };
    }

    /**
     * 对数据进行校验
     */
    public validate(_rule: any, _value: any, callback: any) {
        callback();
    }
}
